export enum OrderFakeStatuses {
  PROCESSING = "Processing",
  TREAT_PLAN = "Treatment plan",
  MANUFACTURING = "Manufacturing",
  SHIPPING = "Shipping",
  DELIVERED = "Delivered",
}
